var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Hero',{attrs:{"title":"Equipas","message":"Informação equipas live","icon":"mdi-account-multiple","layout_type":"users"}}),_c('v-container',[_c('code',[_vm._v("live teams")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }